import React from 'react';
import Link from 'gatsby-link';
import EmailSection from './EmailSection';

export default () => {
  return (
    <div>
      {/* <EmailSection /> */}
      <div className="footer bg-gray-900 text-white">
        <div className="container p-6 md:p-10">
          <div className="flex flex-row mb-4 justify-center">
            <div className="w-full md:w-2/3 text-center">
              {/* <Link
              to="/product"
              className="font-sans text-sm hover:text-white no-underline mr-4"
            >
              Product
            </Link> */}
              <Link
                to="/pricing"
                className="font-sans text-sm hover:text-white no-underline mr-4"
              >
                Pricing
              </Link>
              <Link
                to="/faq"
                className="font-sans text-sm hover:text-white no-underline mr-4"
              >
                FAQ
              </Link>
              <Link
                to="/terms"
                className="font-sans text-sm hover:text-white no-underline mr-4"
              >
                Terms
              </Link>
              <Link
                to="/privacy"
                className="font-sans text-sm hover:text-white no-underline mr-4"
              >
                Privacy Policy
              </Link>
              {/* <Link
                to="/support"
                className="font-sans text-sm hover:text-white no-underline mr-4"
              >
                Support
              </Link> */}
              <a
                href="https://support.shopfeedback.io/"
                className="font-sans text-sm hover:text-white no-underline mr-4"
                target="_blank"
                rel="noopener noreferrer"
              >
                Support
              </a>

              {/* <a
                href="javascript:window.Metomic('ConsentManager:show')"
                className="font-sans text-sm hover:text-white no-underline"
              >
                Manage Cookies
              </a> */}
            </div>
            {/* <div className="w-full md:w-1/2">
            <p className="text-sm font-sans">If you have any questions or just want to say hi, contact me at <a href="#" className= font-bold no-underline">travis@tinyback.io</a></p>
          </div> */}
          </div>
          <div className="flex flex-row justify-center mb-8">
            <Link
              to="/blog/what-is-net-promoter-score/"
              className="font-sans text-sm hover:text-white no-underline mr-4"
            >
              What is Net Promoter Score?
            </Link>
          </div>
          <div className="flex flex-row justify-center text-center">
            <p className="text-xs w-full  md:w-1/2 font-sans text-white">
              NPS is a registered trademark, and Net Promoter Score and Net
              Promoter System are service marks, of Bain & Company, Inc.,
              Satmetrix Systems, Inc. and Fred Reichheld.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
